<div class="nav" [ngClass]="{'horizontal':layout() === 'horizontal', 'vertical':layout() === 'vertical'}">

  <!-- Vertical Navigation Layout -->
  @if (layout() === 'vertical') {
    @for (item of navigation; track item) {
      @if (item.type==='group') {
        <cdk-nav-vertical-group [item]="item"></cdk-nav-vertical-group>
      }
      @if (item.type==='collapsable') {
        <cdk-nav-vertical-collapsable
        [item]="item"></cdk-nav-vertical-collapsable>
      }
      @if (item.type==='item') {
        <cdk-nav-vertical-item [item]="item"></cdk-nav-vertical-item>
      }
    }
  }
  <!-- / Vertical Navigation Layout -->

  <!-- Horizontal Navigation Layout -->
  @if (layout() === 'horizontal') {
    @for (item of navigation; track item) {
      @if (item.type==='group') {
        <cdk-nav-horizontal-collapsable [item]="item"></cdk-nav-horizontal-collapsable>
      }
      @if (item.type==='collapsable') {
        <cdk-nav-horizontal-collapsable
        [item]="item"></cdk-nav-horizontal-collapsable>
      }
      @if (item.type==='item') {
        <cdk-nav-horizontal-item [item]="item"></cdk-nav-horizontal-item>
      }
    }
  }
  <!-- / Horizontal Navigation Layout -->

</div>
